import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyShortName',
  standalone: true,
})
export class CurrencyNameWithoutDetailsPipe implements PipeTransform {
  /**
   * Transforms a full currency name to its short form by extracting the first word.
   *
   * @param {string} value - The string representation of the currency name.
   * @returns {string} - The first word of the trimmed string:
   *  - If the value is null, undefined, or empty, returns an empty string.
   */
  transform(value: string): string {
    return value?.trim().split(/\s+/)[0] || '';
  }
}
